import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from './theme/theme-context';
import { GlobalStyles } from './theme/global-styles';
import { AccessibilityProvider } from './presentation/global/context/accessibility-context';
import { GlobalProvider } from './presentation/global/context/global-context';
import { AppInitializer } from './presentation/global/app-initializer';
import './accessibility.css';

// Obtém o basename detectado automaticamente pelo config.js
const basename = (window as any).__BASENAME__ || '/';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <BrowserRouter basename={basename}>
    <ThemeProvider>
      <GlobalProvider>
        <AppInitializer>
          <AccessibilityProvider>
            <GlobalStyles />
            <App />
          </AccessibilityProvider>
        </AppInitializer>
      </GlobalProvider>
    </ThemeProvider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
